import { create } from "zustand";
import { HintCardStoreProps } from "../components/HintCard/lib/type";

export const useHintCardStore = create<HintCardStoreProps>((set, get, api) => ({
    variant: 'default',
    activeStep: 0,
    hints: [],
    defaultHints: [],
    setHint: (hint) => set(() => ({
        hints: [{ hintCardDetailsButton: false, ...hint }],
        activeStep: 0
    })),
    setHintsList: (hints) => set(() => ({
        hints,
        activeStep: 0
    })),
    setCardVariant: (variant) => set(() => ({
        variant,
    })),
    setNextStep: () => set(({ activeStep }) => ({
        activeStep: activeStep + 1
    })),
    setPrevStep: () => set(({ activeStep }) => ({
        activeStep: activeStep - 1
    })),
    setDefaultHints: (defaultHints, activeStep = 0) => set(() => ({
        defaultHints,
        activeStep
    })),
    resetCurrentHint:() => set(({ defaultHints }) => ({
        hints: defaultHints,
        activeStep: 0
    })),
    reset: () => set(() => ({
        ...api.getInitialState(),
    })),
}));